/* Alma Velari: cuenta atras de «carrito reservado».

   El define va en un asset y no en un <script> dentro del snippet porque el
   cajon se repinta con innerHTML y un script inline no se ejecutaria; con un
   custom element, connectedCallback se dispara solo en cada nodo nuevo. Ver la
   memoria 'scripts-en-bloques-repintados'.

   CUANDO SE REINICIA EL RELOJ, que es lo que mas se ha pensado aqui:
     - carrito vacio            -> se borra lo guardado; el siguiente articulo
                                   empieza de cero
     - nada guardado            -> arranca (primera visita, o pestaña nueva:
                                   sessionStorage no sobrevive a cerrarla)
     - guardado y aun vivo      -> sigue donde estaba, aunque se repinte el cajon
     - guardado, vencido, y HAY
       MAS UNIDADES que cuando  -> vuelve a arrancar: la clienta ha añadido algo
       arranco
     - guardado, vencido, mismas
       unidades                 -> se queda en el aviso naranja

   La comparacion de unidades es lo que hace que el contador reaparezca en una
   visita posterior dentro de la misma pestaña. Sin ella, quien dejara expirar
   el reloj no volveria a verlo nunca. */
customElements.get('av-reserva') ||
  customElements.define(
    'av-reserva',
    class extends HTMLElement {
      connectedCallback() {
        this.clave = 'av-reserva';
        this.minutos = Number(this.dataset.minutos) || 10;
        this.unidades = Number(this.dataset.unidades) || 0;

        // Carrito vacio: no hay nada que reservar y se limpia lo guardado.
        if (this.unidades === 0) {
          this.olvidar();
          return;
        }

        this.salida = this.querySelector('[data-reloj]');
        this.vivo = this.querySelector('[data-vivo]');
        this.expirado = this.querySelector('[data-expirado]');
        if (!this.salida || !this.vivo || !this.expirado) return;

        this.arrancar();
      }

      disconnectedCallback() {
        clearInterval(this.tic);
      }

      // sessionStorage puede estar bloqueado -ventana privada, cookies de
      // terceros-. Si falla, el contador sigue funcionando; lo unico que se
      // pierde es que sobreviva a un repintado del cajon.
      leer() {
        try {
          return JSON.parse(sessionStorage.getItem(this.clave)) || null;
        } catch (e) {
          return null;
        }
      }

      guardar(fin) {
        try {
          sessionStorage.setItem(
            this.clave,
            JSON.stringify({ fin: fin, uds: this.unidades })
          );
        } catch (e) {
          /* sin persistencia, pero el contador funciona */
        }
      }

      olvidar() {
        try {
          sessionStorage.removeItem(this.clave);
        } catch (e) {
          /* nada que limpiar */
        }
      }

      arrancar() {
        const ahora = Date.now();
        const guardado = this.leer();

        if (guardado && guardado.fin > ahora) {
          this.fin = guardado.fin;
        } else if (guardado && this.unidades <= (guardado.uds || 0)) {
          // Vencido y no ha añadido nada: se queda en el aviso.
          this.expirar();
          return;
        } else {
          this.fin = ahora + this.minutos * 60000;
          this.guardar(this.fin);
        }

        this.pintar();
        this.tic = setInterval(() => this.pintar(), 1000);
      }

      expirar() {
        clearInterval(this.tic);
        this.classList.add('av-reserva--fuera');
        this.vivo.hidden = true;
        this.expirado.hidden = false;
      }

      pintar() {
        const resto = Math.round((this.fin - Date.now()) / 1000);
        if (resto <= 0) {
          this.expirar();
          return;
        }
        const m = Math.floor(resto / 60);
        const s = resto % 60;
        this.salida.textContent =
          String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
      }
    }
  );
